import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configureStore  } from '@reduxjs/toolkit'
import "./Fonts/Bubble.woff2";
import { Provider, createStoreHook, createSelectorHook, createDispatchHook } from 'react-redux';
import reducer from './Redux/reducer';

const MyContext = React.createContext(null)
export const useStore = createStoreHook(MyContext)

const store = configureStore({
    reducer: reducer,
})
// const store = createStore(reducer)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <Provider store={store}>
    <App />
      </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
